import ButtonUpdateFileType from './ButtonUpdateFileType';

export default ButtonUpdateFileType;